export default __webpack_public_path__ + "static/media/logo.0a79f87f.svg";